/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const updatePlatformUserProvince = params => {
  return axios.post(`${base}/adminuser/edit_adminuser_province/${params.id}`, params)
}
export const getPlatformUsersProvince = id => {
  return axios.get(`${base}/adminuser/getprovince/${id}`)
}



// WEBPACK FOOTER //
// ./src/views/platform-user-province/platform-user-province.api.js